import { useState, useEffect } from 'react';

// Returns 'mobile' | 'tablet' | 'desktop'
// mobile:  < 640px
// tablet:  640px – 1023px
// desktop: ≥ 1024px
export default function useBreakpoint() {
  const getBreakpoint = () => {
    const w = window.innerWidth;
    if (w < 640) return 'mobile';
    if (w < 1024) return 'tablet';
    return 'desktop';
  };

  const [bp, setBp] = useState(getBreakpoint);

  useEffect(() => {
    const handler = () => setBp(getBreakpoint());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return bp;
}
